import base from "./API/Base"
import record from "./API/Records"
import room from "./API/Room"
import reservation from "./API/Reservation"

export default {
  base,
  record,
  room,
  reservation
}
